var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CountTo',{attrs:{"startVal":_vm.start,"endVal":_vm.end,"duration":_vm.duration}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }